export const CATALOG_SHOPS_URL = `catalog/shops`;
